/**
 * TODO: Feature flag function
 * If current env is production, depends on the companyId
 * Otherwise always returns true
 * @param {string} companyId
 * @returns {boolean}
 */
/* const checkFeatureFlag = (companyId) => {
  if (!companyId) {
    return false
  }

  return [
    '5ede3f0a1746310018d42a3d', // J2BD
    // '5ee08e58ad56dd00271a433f', // Hollo
    // '5fe0d317ce309d0029cebbc5', // Staging
    '5fe0da154fbde1003fc656a3', // Develop
  ].includes(companyId)

  // return true
} */
const checkFeatureFlag = ['job2bedone-partners-app.hollo.io'].includes(
  window?.location?.hostname,
)

module.exports = {
  checkFeatureFlag,
}
